<template>
  <label class="asset-status-filter">وضعیت
    <select :value="value" @change="$emit('input', $event.target.value)">
      <option value="all">همه موارد موجود</option>
      <option value="active">فعال</option>
      <option value="inactive">غیرفعال</option>
      <option value="deleted">حذف‌شده‌ها (سوابق)</option>
    </select>
  </label>
</template>
<script>export default { props: { value: { type: String, default: 'all' } } };</script>
<style scoped>.asset-status-filter { display: inline-flex; gap: 8px; align-items: center; margin-inline-end: 16px; } select { min-height: 40px; border: 1px solid #bcc8dc; border-radius: 8px; padding: 6px; }</style>
